import React from "react";

export default function AssessmentOverview(props: any) {
  const answersObject = props.answers; 
  const answersArray = Object.values(answersObject);
  const scores = answersArray.map((a: any) => a.score);
  const highestScore = Math.max(...scores);
  const lowestScore = Math.min(...scores);
  const averageScore = scores.reduce((sum, score) => sum + score, 0) / scores.length;
  const avgRounded = Number(averageScore.toFixed(2));

  return (
    <section className="border border-green-200 rounded-lg  bg-green-50 p-8 mb-8 border-b border-momentum-accent/10">
      <h2 className="text-2xl font-bold text-momentum-dark mb-4">Assessment Overview</h2>
      <p className="text-momentum-gray mb-6 leading-relaxed">
        Based on 20 operational assessment questions, your agency demonstrates a keen interest in adopting leading-edge technology but also an
        understanding of the need to implement consistent processes and performance metrics first.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <div className="bg-card p-6 rounded-xl text-center hover-lift border border-momentum-accent/20">
          <div className="text-4xl font-bold text-momentum-primary mb-2">{props.totalScore}</div>
          <div className="text-sm text-muted-foreground font-medium">
            Total Points
            <br />
            <span className="text-xs opacity-70">(Out of 100)</span>
          </div>
        </div>
        <div className="bg-card p-6 rounded-xl text-center hover-lift border border-momentum-accent/20">
          <div className="text-4xl font-bold text-momentum-primary mb-2">{highestScore}</div>
          <div className="text-sm text-muted-foreground font-medium">
            Highest Score
            <br />
            <span className="text-xs opacity-70">(20 Questions)</span>
          </div>
        </div>
        <div className="bg-card p-6 rounded-xl text-center hover-lift border border-momentum-accent/20">
          <div className="text-4xl font-bold text-momentum-primary mb-2">{lowestScore}</div>
          <div className="text-sm text-muted-foreground font-medium">
            Lowest Score
            <br />
            <span className="text-xs opacity-70">(20 Questions)</span>
          </div>
        </div>
        <div className="bg-card p-6 rounded-xl text-center hover-lift border border-momentum-accent/20">
          <div className="text-4xl font-bold text-momentum-primary mb-2">{averageScore}</div>
          <div className="text-sm text-muted-foreground font-medium">
            Average Score
            <br />
            <span className="text-xs opacity-70">(20 Questions)</span>
          </div>
        </div>
      </div>
    </section>
  );
}
